<!-- REM: adjust this component to new availability state setup -->

<div
  class="header-bar"
  style="display: flex; justify-content: space-between"
  xmlns="http://www.w3.org/1999/html"
>
  <h1>Supplier Availability</h1>
  <div class="style2023 mt-2">
    <button
      type="button"
      pButton
      icon="{{ !isDownloading ? 'fa ui-icon-file-download' : 'fa fa-spin fa-circle-o-notch' }}"
      label="{{ !isDownloading ? 'Download CSV' : 'Downloading' }}"
      class="button-style btn-md ui-tertiary-button"
      (click)="downloadReport()"
      [disabled]="isDownloading"
    ></button>
  </div>
</div>
<div class="">
  <div class="">
    <div class="">
      <div class="filter-content-container style2023">
        <div>
          <h2 style="margin-top: 5px">Search Supplier</h2>
        </div>
        <form #form="ngForm" (ngSubmit)="search()" style="width: 100%">
          <div
            class="form-group"
            style="
              display: grid;
              grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
              grid-gap: 20px;
            "
          >
            <div class="input-group flex align-items-center">
              <div class="input-group-prepend white-space-nowrap group-label">From</div>
              <div class="input-group-item flex-grow-1 white-space-nowrap justify-content-between">
                <i
                  class="fa fa-calendar mr-3 clickable-calendar-icon"
                  (click)="fromDate.showOverlay()"
                ></i>
                <p-calendar
                  name="fromDate"
                  dateFormat="dd/mm/yy"
                  class="custom-calendar-template"
                  [style]="{ 'max-width': '90px' }"
                  #fromDate
                  [(ngModel)]="filterVal.filters.fromDate.value"
                >
                </p-calendar>
              </div>
            </div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    class="filter-dropdown input-group-filter"
                    name="supplierOptions"
                    defaultLabel="Select Supplier"
                    [options]="suppliers"
                    [(ngModel)]="this.filterVal.filters.suppliers.value"
                  ></p-multiSelect>
                </div>
              </div>
            </div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    class="filter-dropdown input-group-filter"
                    name="classificationOptions"
                    defaultLabel="Select Classification"
                    [options]="classifications"
                    [(ngModel)]="this.filterVal.filters.classifications.value"
                  ></p-multiSelect>
                </div>
              </div>
            </div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    class="filter-dropdown input-group-filter"
                    name="areaOptions"
                    defaultLabel="Select Region"
                    [options]="areaOptions"
                    [(ngModel)]="this.filterVal.filters.areas.value"
                    (ngModelChange)="regionSelected()"
                  ></p-multiSelect>
                </div>
              </div>
            </div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    class="filter-dropdown input-group-filter"
                    name="regionOptions"
                    defaultLabel="Select Area"
                    [options]="regionOptions"
                    [(ngModel)]="this.filterVal.filters.regions.value"
                  ></p-multiSelect>
                </div>
              </div>
            </div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    class="filter-dropdown input-group-filter"
                    name="tagOptions"
                    defaultLabel="Select Tag(s)"
                    [options]="tags"
                    [(ngModel)]="this.filterVal.filters.tags.value"
                  ></p-multiSelect>
                </div>
              </div>
            </div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-dropdown
                    class="input-group-filter"
                    name="lastJobSearchPeriod"
                    placeholder="Select Last Job Search Period"
                    [options]="lastJobSearchPeriodOptions"
                    [(ngModel)]="filterVal.filters.lastJobSearchPeriod.value"
                  ></p-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h3 style="margin-top: 15px">Availability</h3>
          </div>
          <div class="form-group" style="display: flex; grid-gap: 20px">
            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-prepend white-space-nowrap">
                  {{ gridDates[0] | date : 'MMMM d' }}
                </div>

                <div class="input-group-item">
                  <p-multiSelect
                    class="filter-dropdown input-group-filter"
                    name="day1Availability"
                    defaultLabel="Select Availability"
                    [options]="availabilityStateOptions"
                    [(ngModel)]="this.filterVal.filters.day1Availability.value"
                  ></p-multiSelect>
                </div>
              </div>
            </div>
            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-prepend white-space-nowrap">
                  {{ gridDates[1] | date : 'MMMM d' }}
                </div>

                <div class="input-group-item">
                  <p-multiSelect
                    class="filter-dropdown input-group-filter"
                    name="day2Availability"
                    defaultLabel="Select Availability"
                    [options]="availabilityStateOptions"
                    [(ngModel)]="this.filterVal.filters.day2Availability.value"
                  ></p-multiSelect>
                </div>
              </div>
            </div>
            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-prepend white-space-nowrap">
                  {{ gridDates[2] | date : 'MMMM d' }}
                </div>

                <div class="input-group-item">
                  <p-multiSelect
                    class="filter-dropdown input-group-filter"
                    name="day3Availability"
                    defaultLabel="Select Availability"
                    [options]="availabilityStateOptions"
                    [(ngModel)]="this.filterVal.filters.day3Availability.value"
                  ></p-multiSelect>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group" style="display: flex; grid-gap: 20px; margin-top: 15px">
            <button
              pButton
              type="submit"
              label="Search"
              [disabled]="form.invalid"
              class="button-style btn-md ui-primary-button ml-0"
              icon="fa ui-icon-search"
            ></button>
            <button
              pButton
              type="button"
              icon="fa ui-icon-restore"
              class="button-style btn-md ui-tertiary-button ml-2"
              (click)="resetFilters(dt)"
            ></button>
          </div>
        </form>
      </div>
      <div class="content-container">
        <div
          *ngIf="isLoading && !isLoaded"
          style="text-align: center; font-size: 1.25rem; z-index: 99; padding: 10px"
        >
          <i class="fa fa-spinner fa-spin"></i>&nbsp; Loading Supplier Availability, Please Wait...
        </div>

        <p-table
          #dt
          [value]="page.items"
          [lazy]="true"
          [rows]="10"
          [responsive]="true"
          [paginator]="true"
          resizableColumns="true"
          [first]="filterVal.first"
          [totalRecords]="page.total"
          (onLazyLoad)="onGridLazyLoad($event)"
          [hidden]="!isLoaded"
          [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
          [pageLinks]="3"
          [sortField]="filterVal.sortField"
          [sortOrder]="filterVal.sortOrder"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pResizableColumn pSortableColumn="supplierName" style="width: 150px">
                Supplier Name
              </th>
              <th pResizableColumn pSortableColumn="classification" style="width: 120px">
                Classification
              </th>
              <th pResizableColumn pSortableColumn="totalJobsCompleted" style="width: 120px">
                Total Jobs Completed
              </th>
              <th pSortableColumn="lastJobCompleted" style="width: 115px">Last Job Completed</th>
              <th pResizableColumn pSortableColumn="lastJobSearch" style="width: 115px">
                Last Job Search
              </th>
              <th pResizableColumn pSortableColumn="noOfWatchedJobs" style="width: 115px">
                Watched Jobs
              </th>
              <th pResizableColumn style="width: 115px">Total Jobs in Plan</th>
              <th pResizableColumn pSortableColumn="contactNumber" style="width: 140px">
                Contact Number
              </th>
              <th pResizableColumn pSortableColumn="area" style="width: 150px">Area</th>
              <th pResizableColumn pSortableColumn="carryoverApproval" style="width: 105px">
                Carryover Approval
              </th>
              <th pResizableColumn style="width: 250px">Tags</th>
              <th
                class="day-detail"
                [ngClass]="{
                  'date-column': true,
                  'first-date-column': i === 0,
                  'last-date-column': i === 2
                }"
                *ngFor="let gDate of gridDates; let i = index"
              >
                {{ gDate | date : 'MMM d' }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item">
              <td
                class="supplier-name-clickable"
                (click)="navigateToSupplier(item.supplierId)"
                style="width: 150px"
              >
                {{ item.supplierName }}
              </td>
              <td class="align-center" style="width: 120px">{{ item.classification }}</td>
              <td class="align-center" style="width: 120px">
                <div class="sad-column-details">
                  <span>{{ item.totalJobsCompleted }}</span>
                  <span class="sad-column-details-sub"
                    >Last 30 Days: {{ item.totalJobsCompletedLast30Days }}</span
                  >
                </div>
              </td>
              <td class="align-center" style="width: 115px">
                {{
                  item.lastJobCompletedDate
                    ? (item.lastJobCompletedDate | date : "d MMM, 'yy")
                    : 'Unknown'
                }}
              </td>
              <td class="align-center" style="width: 115px">
                {{
                  isDefaultDate(item.lastJobSearch)
                    ? 'Unknown'
                    : (item.lastJobSearch | date : "d MMM, 'yy")
                }}
              </td>
              <td class="align-center" style="width: 115px">{{ item.totalWatchedJobs }}</td>
              <td class="align-center" style="width: 115px">{{ item.upcomingJobs }}</td>
              <td class="align-center" style="width: 140px">
                <div class="sad-column-details">
                  <span
                    ><a href="tel:{{ item.contactNumber }}">{{ item.contactNumber }}</a></span
                  >
                  <span class="sad-column-details-sub"
                    >Last Call:
                    {{
                      item.lastOutboundCallDate
                        ? (item.lastOutboundCallDate | date : "d MMM, 'yy")
                        : 'N/A'
                    }}</span
                  >
                </div>
              </td>
              <td class="align-center" style="width: 150px">{{ item.area }}</td>
              <td
                class="align-center"
                style="width: 105px"
                [ngClass]="{ 'text-success': item.carryoverApproval }"
              >
                {{ item.carryoverApproval ? 'Approved' : 'N/A' }}
              </td>
              <td style="width: 250px">
                <div class="supplier-tag-container">
                  <div
                    class="supplier-tag"
                    *ngFor="let tag of item.tagEntities"
                    pTooltip="{{ tag.description }}"
                    (click)="selectTag(tag)"
                  >
                    {{ tag.name }}
                  </div>
                </div>
              </td>
              <td
                class="align-center day-detail"
                [ngClass]="{
                  'date-column': true,
                  'first-date-column': i === 0,
                  'last-date-column': i === 2
                }"
                *ngFor="let dayDetail of item.specificDayDetail; let i = index"
                (click)="updateAvailabilityStatus(item, dayDetail)"
              >
                <i
                  class="fa fa-signal day-detail-selector"
                  [ngClass]="{
                    'fa-gradient-1': dayDetail.hoursOfWork <= 4,
                    'fa-gradient-2': dayDetail.hoursOfWork > 4 && dayDetail.hoursOfWork <= 6,
                    'fa-gradient-3': dayDetail.hoursOfWork > 6
                  }"
                  aria-hidden="true"
                  pTooltip="{{ dayDetail.hoursOfWork }} Hour{{
                    dayDetail.hoursOfWork > 1 ? 's' : ''
                  }} Driving"
                  *ngIf="
                    dayDetail.availabilityState == AvailabilityStateEnum.available &&
                    dayDetail.hoursOfWork > 0
                  "
                ></i>
                <i
                  class="fa fa-check grid-icon-circle available day-detail-selector"
                  aria-hidden="true"
                  *ngIf="
                    dayDetail.availabilityState == AvailabilityStateEnum.available &&
                    dayDetail.hoursOfWork <= 0
                  "
                  pTooltip="Driver has said they are available (and does not have any work set)"
                ></i>
                <i
                  class="fa fa-question grid-icon-circle not-set day-detail-selector"
                  aria-hidden="true"
                  *ngIf="dayDetail.availabilityState == AvailabilityStateEnum.unset"
                  pTooltip="Driver has not set their availability in their calendar (supplier schedule)"
                ></i>
                <i
                  class="fa fa-times grid-icon-circle not-available day-detail-selector"
                  aria-hidden="true"
                  *ngIf="dayDetail.availabilityState == AvailabilityStateEnum.unavailable"
                  pTooltip="Driver has said they are not available"
                ></i>
                <i
                  class="fa fa-minus-circle grid-icon-circle not-available day-detail-selector"
                  aria-hidden="true"
                  *ngIf="dayDetail.availabilityState == AvailabilityStateEnum.doNotDisturb"
                  pTooltip="Driver is not able to work and should not be called"
                ></i>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <ng-template #loading>Loading...</ng-template>
      </div>
    </div>
  </div>
</div>
